import React from 'react';
import { Alert } from 'react-bootstrap-5';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCircleXmark } from '@fortawesome/pro-solid-svg-icons';
import flatten from 'lodash/flatten';
import PropTypes from 'prop-types';

export default function ErrorAlert({ hasErrors, errorMessages }) {
  const formattedErrors = Array.isArray(errorMessages) ? errorMessages : flatten(Object.values(errorMessages));

  return (
    hasErrors && (
      <>
        <Alert className="alert-icon mb-2" variant="danger">
          <FontAwesomeIcon icon={faCircleXmark}/>
          <h6 className="mt-0 alert-heading mb-1">
            The following errors occurred when trying to save this form. Please fix and re-submit.
          </h6>
          <ul className="mb-0">
            {formattedErrors.map((errorMessage, index) => (
              <li key={index}>{errorMessage}</li>
            ))}
          </ul>
        </Alert>
      </>
    )
  );
}

ErrorAlert.propTypes = {
  errorMessages: PropTypes.oneOfType([
    PropTypes.object,
    PropTypes.array
  ]),
  hasErrors: PropTypes.bool.isRequired
};
